<template>
    <oss-dialog
        v-model="dialog"
        :minWidth="width"
        :actions="actions"
        title="Importez votre fichier"
        :valid-loading="false"
    >
        <v-window v-model="wizardStep" touchless>
            <v-window-item :value="0" class="py-3">
                <FixedAssetsImport
                    v-if="wizardStep === 0"
                    ref="importComponent"
                    :documentType="'FIXED_ASSETS'"
                    :actions="actions"
                    @documentImported="onDocumentImported($event)"
                    :min-width="width"
                />
            </v-window-item>
            <v-window-item :value="2" class="py-0">
                <UploadDocuments
                    v-if="
                        currentUser.profile.configuration.bankTransaction.import && wizardStep === 2
                    "
                    :showFirstPrevious="true"
                    :companyId="companyId"
                    :documentType="'BANK_STATEMENT'"
                    :multiple="true"
                    :freeTag="false"
                    :inExtensions="['pdf']"
                    :actions="actions"
                    @back="back()"
                    @files-uploaded="imported"
                    @new-document="imported"
                    :min-width="width"
                >
                </UploadDocuments>
            </v-window-item>
        </v-window>
    </oss-dialog>
</template>

<script lang="ts">
import { User } from "../../store/store";

import FixedAssetsImport from "../import/FixedAssetsImport.vue";

import { DialogAction } from "../../services/dialogAction";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";

@Component({
    components: {
        FixedAssetsImport,
    },
    emits: ["bankTransactionImported", "excelTransactionImported", "close", "query-done"],
})
export class CheckFixedAssetPreviousImport extends Vue {
    @Model() value: boolean;
    @Prop({ default: "" }) readonly title: string;

    pattern = /(0{1,})$/;

    wizardStep = 0;

    width = "90%";
    // changeWidth() {
    //     //@ts-ignore
    //     if (this.$refs.importComponent?.step !== 0) {
    //         this.width = "90%";
    //     } else {
    //         this.width = "90%";
    //     }
    // }
    stream = null;

    actions = {
        action: new DialogAction(),
    };

    get currentUser(): User {
        return this.$store.state.user;
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get dialog() {
        return this.value;
    }

    set dialog(data) {
        this.value = data;
    }

    beforeMount() {
        //this.actions.action.display = false
    }

    close = function emitEventToCloseDialog() {
        this.$emit("close");
    };

    imported() {
        this.$emit("bankTransactionImported");
        this.close();
    }

    importedExcel() {
        this.$emit("excelTransactionImported");
        this.close();
    }

    back = function emitActionBackFromBankTransaction() {
        this.wizardStep = 0;
    };

    async onDocumentImported(processedData) {
        if (processedData.length) {
            this.$emit("query-done", {
                fixedAssetsFile: processedData,
            });
            this.$emit("close");
        }
    }
}

export default toNative(CheckFixedAssetPreviousImport);
</script>
